import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import commaNumber from "comma-number";
import Loader from "../../../../../../settings/loader";
import "../style.scss";

function Slide1(props) {
  const [data, setData] = useState({
    statistics: null,
    userCount: 0,
  });
  const [load, setLoad] = useState(0);

  const COLORS = {
    web: "#0088FE",
    android: "#00C49F",
    ios: "#FFBB28",
  };

  useEffect(() => {
    if (props.data.state && !load) {
      const statistics = props.data.result.statistics;
      const userMap = props.data.result.userMap;
      const userCount = Object.keys(userMap).length;

      setData({
        statistics: statistics,
        userCount: userCount,
      });
      setLoad(1);
    }
  }, [props.data, load]);

  // Function to determine the most used platform
  const getMostUsedPlatform = () => {
    if (!data.statistics) return null;

    const platforms = [
      { name: "web", count: data.statistics.web || 0 },
      { name: "android", count: data.statistics.android || 0 },
      { name: "ios", count: data.statistics.ios || 0 },
    ];

    return platforms.reduce(
      (max, platform) => (platform.count > max.count ? platform : max),
      platforms[0]
    );
  };

  const mostUsedPlatform = getMostUsedPlatform();

  return (
    <div className="device-analytics-slide slide1">
      {!load ? (
        <Loader />
      ) : (
        <div className="stats-cards">
          <div className="stat-card">
            <h3>Total Users</h3>
            <div className="stat-value">{commaNumber(data.userCount)}</div>
            <div className="stat-label">Registered Users</div>
          </div>

          <div
            className="stat-card"
            style={{ borderTop: `4px solid ${COLORS.web}` }}
          >
            {mostUsedPlatform?.name === "web" && (
              <div className="most-used-badge-top">
                <FontAwesomeIcon
                  icon={["fas", "crown"]}
                  style={{ marginRight: "4px" }}
                />
                Most Used
              </div>
            )}
            <h3>
              <FontAwesomeIcon
                icon={["fas", "desktop"]}
                style={{ marginRight: "8px" }}
              />
              Web
            </h3>
            <div className="stat-value">
              {commaNumber(data.statistics?.web || 0)}
            </div>
            <div className="stat-label">Desktop Logins</div>
          </div>

          <div
            className="stat-card"
            style={{ borderTop: `4px solid ${COLORS.android}` }}
          >
            {mostUsedPlatform?.name === "android" && (
              <div className="most-used-badge-top">
                <FontAwesomeIcon
                  icon={["fas", "crown"]}
                  style={{ marginRight: "4px" }}
                />
                Most Used
              </div>
            )}
            <h3>
              <FontAwesomeIcon
                icon={["fas", "mobile-alt"]}
                style={{ marginRight: "8px" }}
              />
              Android
            </h3>
            <div className="stat-value">
              {commaNumber(data.statistics?.android || 0)}
            </div>
            <div className="stat-label">Android Logins</div>
          </div>

          <div
            className="stat-card"
            style={{ borderTop: `4px solid ${COLORS.ios}` }}
          >
            {mostUsedPlatform?.name === "ios" && (
              <div className="most-used-badge-top">
                <FontAwesomeIcon
                  icon={["fas", "crown"]}
                  style={{ marginRight: "4px" }}
                />
                Most Used
              </div>
            )}
            <h3>
              <FontAwesomeIcon
                icon={["fab", "apple"]}
                style={{ marginRight: "8px" }}
              />
              iOS
            </h3>
            <div className="stat-value">
              {commaNumber(data.statistics?.ios || 0)}
            </div>
            <div className="stat-label">iOS Logins</div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Slide1;
